import { Injectable } from '@angular/core';

export type FaqItem = {
  id: string;
  question: string;
  answer: string;
};

export type FaqSection = {
  title: string;
  items: FaqItem[];
};

@Injectable({ providedIn: 'root' })
export class FaqSectionService {
  readonly sections: FaqSection[] = [
    {
      title: 'Booking & Appointments',
      items: [
        {
          id: 'booking-1',
          question: 'How do I book, reschedule, or cancel?',
          answer:
            'You can book online in minutes. Need to reschedule or cancel? We will help with a quick change so your pet stays on a calm routine.'
        },
        {
          id: 'booking-2',
          question: 'How long does a grooming session take?',
          answer:
            'Most appointments take 1.5-3 hours depending on coat type, service level, and your pet comfort. We confirm timing at check-in.'
        },
        {
          id: 'booking-3',
          question: 'Can I stay during the grooming?',
          answer:
            'For safety and focus, we do not offer in-room stays. You will receive clear updates and can reach us anytime during the visit.'
        },
        {
          id: 'booking-4',
          question: 'Are vaccinations required?',
          answer:
            'Yes, we follow standard safety guidelines. We will let you know exactly which vaccinations are required at booking.'
        }
      ]
    },
    {
      title: 'Grooming & Care',
      items: [
        {
          id: 'care-1',
          question: 'What is included in a standard grooming?',
          answer:
            'A gentle bath, dry, brush-out, light trim, nail care, ear cleaning, and a comfort-focused finish tailored to your pet.'
        },
        {
          id: 'care-2',
          question: 'How often should my pet be groomed?',
          answer:
            'Most dogs and cats benefit every 4-8 weeks. We recommend a cadence based on coat type, lifestyle, and skin health.'
        },
        {
          id: 'care-3',
          question: 'Do you groom cats?',
          answer:
            'Yes. Our groomers are trained in calm, cat-friendly handling with quiet, low-stress techniques and shorter sessions when needed.'
        },
        {
          id: 'care-4',
          question: 'What add-on services do you offer?',
          answer:
            'Popular add-ons include deshedding, spa treatments, nail grinding, ear care, and dental freshening.'
        },
        {
          id: 'care-5',
          question: 'How is pricing determined?',
          answer:
            'Pricing is based on size, coat condition, service level, and time required. We are transparent and discuss any changes up front.'
        }
      ]
    },
  ];
}
